export const VIDEO = 'VIDEO';
export const IMAGE = 'IMAGE';
export const HEIC = 'HEIC';
export const OTHER = 'OTHER';
export const AUDIO = 'AUDIO';
export const FONT = 'FONT';
export const PDF = 'PDF';